import styled from '@emotion/styled/macro';

export const Total = styled.div`
  font-weight: bold;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.color.dark1};
`;
